export default __webpack_public_path__ + "static/media/caret-right.9cba06db.svg";